import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable,throwError  } from 'rxjs';
import { EnvService } from '../../../core/env.service';
import { retry, catchError } from 'rxjs/operators';

@Injectable()
export class MenuItemService {
    data: any[];
    env: EnvService;
    constructor(private _httpClient: HttpClient,public _env: EnvService) {
      this.env = _env;
     }
     
     getMenuItem(): Observable<any> {
      return this._httpClient.get<any>(this.env.apictgf + 'User/GetMenu');
  }
}